/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
	var pathname = window.location.pathname;
  	
    if(pathname=="/a/gc/gift-card/"){
    	$("body").append('<div class="popup-wrapper signup-popup"><div class="popup-div"><span class="popup-close-btn popup-modal-close">Close</span><div class="popup-result"></div></div></div>');
  
        $(".popup-result").html('<p style="font-size:18px;font-weight:bold;">The perfect gift starts here.</p><p><b>How does it work?</b><br>Choose the gift card design you like, select gift value, fill in all other mandatory fields and add your personalised gift message. Once payment has been made, your personalised digital gift card will be sent automatically via email to the recipient.</p><p><b>When will my friend receive the gift card?</b><br>Once payment has been confirmed, your friend will receive your digital gift card in her email inbox. You can also choose the date that you would like your friend to receive your digital gift card.</p><p><b>What if I don’t have my friend’s email?</b><br>You can send it to yourself and print out the gift card on your own to send to your friend.</p><p><b>How long is the gift card valid for?</b><br>Each gift card will come with a unique code, and will be valid for six (6) months from the date of purchase of the gift card.</p><p>If you or your friend require any help along the way, feel free to contact us at <a href="mailto:enquiry@estlab.shop" target="_blank"><u>enquiry@estlab.shop</u>!</a></p>');
        $(".signup-popup").show();

        $(".popup-modal-close").bind('click', function(){
            $(".signup-popup").remove();
        });
    }
});